import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import mixins from '../../../../styles/mixins';

export const useStyles = makeStyles<Theme>()((theme) => ({
  postWrapper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    marginTop: 4,
    padding: 16,
  },
  postWrapperShadow: {
    boxShadow: `0 1px 3px rgba(0, 0, 0, 0.1)`,
  },
  header: {
    display: 'flex',
  },
  userInfo: {
    display: 'flex',
    marginLeft: 8,
    flex: 1,
    flexDirection: 'column',
  },
  createdAt: {
    color: theme.palette.grey[600],
  },

  content: {
    marginTop: 8,
  },
  editedPostContent: {},
  editedPostBottom: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8,
  },
  uploadFileButton: {
    height: 32,
    lineHeight: '24px',
    padding: '4px 8px',
    display: 'inline-flex',
    marginBottom: 4,
    '& svg': {
      marginRight: 8,
    },
  },
  filesWrapper: {
    marginTop: 8,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  repliedPostWrapper: {
    borderLeft: `${theme.palette.primary.main} 2px solid`,
  },
  footer: {
    marginTop: 8,
    '& svg + svg': {
      marginLeft: 16,
    },
    ...mixins.appSvg,
  },
  commentsWrapper: {
    marginTop: '8px',
    paddingTop: '8px',
  },
  commentsWrapperBorder: {
    borderTop: `1px solid ${theme.palette.grey[200]}`,
  },
  newCommentWrapper: {
    width: '100%',
    marginTop: 8,
    '& > div + div': {
      marginTop: 16,
    },
    '& > div:first-of-type': {
      marginTop: 0,
    },
  },
  answeredCommentWrapper: {
    borderLeft: `${theme.palette.primary.main} 2px solid`,
    marginLeft: 32,
  },

  uploadedFilesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  newCommentData: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 16,
    ...mixins.appSvg,
    '& svg': {
      marginTop: '8px',
      ...mixins.appSvg['& svg'],
    },
  },

  menuItem: {
    '& svg': {
      marginRight: 8,
    },
  },
  delete: {
    color: theme.palette.red[300],
  },
}));
